window.odTheme = window.odTheme || {};

window.odTheme.MobileMenu = (function() {
  
  function MobileMenu(){
    this.data = {
      activeMenu: {},
      active: false,
      megaMenu: [],
      tier_1: {},
      tier_2: {},
      tier_3: {},
      level: 0
    };

    this.featuredLinkPrefix = 'All';
    this.getMenuData();
    this.bindEvents();
  }

  MobileMenu.prototype = window.odTheme.utils.extend({}, MobileMenu.prototype, {

    getMenuData: function($section) {
      var self = this;

      var menuHtmlCollectionData = document.getElementById('Navigation').children;
      var megaMenuData = Array.from(menuHtmlCollectionData);

      var parentGroup,subGroup,childGroup;

      for (var i = 0; i < megaMenuData.length; i++) {
        var item = megaMenuData[i];
        let title = item.innerText.toLowerCase();
        title = title.split(' ').join('-').replaceAll("'", "");

        var group = {
          title: item.innerText,
          level: parseInt(item.dataset.level),
          url: item.dataset.ref,
          hash: item.dataset.ref == '#' ? '#' : '',
          handle: title,
          parentHandle: '',
          featuredLink: item.innerText.startsWith(self.featuredLinkPrefix),
          childLinks: []
        };

        if (group.level == 1) {
          group.parentHandle = group.handle;
          group.parentTitle = group.title;
          self.data.megaMenu.push(group)
          parentGroup = self.data.megaMenu[self.data.megaMenu.length - 1];
        }
        else if (group.level == 2){
          group.parentHandle = parentGroup.handle;
          group.parentTitle = parentGroup.title;
          parentGroup.childLinks.push(group);
          subGroup = parentGroup.childLinks[parentGroup.childLinks.length - 1];

        }
        else if (group.level == 3){
          group.parentHandle = subGroup.handle;
          group.parentTitle = subGroup.title;
          subGroup.childLinks.push(group);
          childGroup = subGroup.childLinks[subGroup.childLinks.length - 1];

        }
        else if (group.level == 4){
          group.parentHandle = childGroup.handle;
          group.parentTitle = childGroup.title;
          childGroup.childLinks.push(group);
        }

      }
      //don't set active on page load
      // self.data.activeMenu = self.data.megaMenu[0];
      
    },
    
    bindEvents: function(){
    	var self = this;

      var menuContainer = document.querySelector('[data-mobile-menu-binder]');
      

      for (var i = 0; i < self.data.megaMenu.length; i++) {
        let menu = self.data.megaMenu[i];
        
        if (menu.childLinks.length > 0){
          let handle = menu.handle;
          console.log(handle)
          let parentButton = document.querySelector(`[data-mobile-menu="${handle}"] .mobile-menu-title`);
          parentButton?.classList.add('has-arrow');
        }
        
      }

      tinybind.bind(menuContainer, {
        menu: self.data,
        methods: {
          setSelectedMenu: function(event, binding) {
            self.setSelectedMenu(event, binding);
          },
          hideMenu: function(event, binding) {
            self.hideMenu(event, binding);
          },
          setSelectedGroup: function(event, binding){
            if (event.currentTarget.dataset.hash.length > 0){
              self.setSelectedGroup(event, binding);
            }
            
          },
          goBackMenu: function(event, binding){
            self.goBackMenu(event, binding);
          },
          resetMenu: function(event, binding){
            self.resetMenu(event, binding);
          }
        }
      });
    },

    goBackMenu: function(event, binding){
      var self = this;
      var currentTier = parseInt(event.currentTarget.dataset.tier);
      var level = currentTier;
      
      self.data.level = self.data.level - 1;

      switch(level) {
        case 1:
          self.data.tier_1 = [];
          self.data.tier_1.active = '';
          self.data.tier_1.activeTitle = '';
          break;
        case 2:
          self.data.tier_2 = []
          self.data.tier_2.active = '';
          self.data.tier_2.activeTitle = ''

          self.data.tier_3 = [];
          break;
        case 3:
          self.data.tier_3 = []
          self.data.tier_3.active = '';
          self.data.tier_3.activeTitle = ''
          break;
        default:
          // code block
      }

      

    },

    resetMenu: function(){
      var self = this;
      self.data.activeMenu = {};
      self.data.level = 0;
      self.resetSelectedTiers();
      self.data.active = true;
    },

    setSelectedGroup: function(event, binding){
      var self = this;
      var group = binding.group
      var level = group.level;

      self.data.level = level;

      switch(level) {
        case 1:
          self.data.tier_1 = group.childLinks || [];
          self.data.tier_1.active = group.handle;
          self.data.tier_1.activeTitle = group.title;
          break;
        case 2:
          self.data.tier_2 = group.childLinks || [];
          self.data.tier_2.active = group.handle;
          self.data.tier_2.activeTitle = group.title;

          self.data.tier_3 = [];
          break;
        case 3:
          self.data.tier_3 = group.childLinks || [];
          self.data.tier_3.active = group.handle;
          self.data.tier_3.activeTitle = group.title;
          break;
        default:
          // code block
      }

      
    },

    hideMenu: function(){
      var self = this;

      self.data.active = false;
    },

    setSelectedMenu: function(event, binding){
      var self = this;
      var handle = event.currentTarget.dataset.mobileMenu;
      self.data.level = 1;

      self.data.activeMenu = self.data.megaMenu.find(function(item){
        if (item.handle == handle){
          return item;
        }
      });

      self.resetSelectedTiers();
      self.data.active = true;
    },

    resetSelectedTiers: function(){
      var self = this;

      self.data.tier_2 = [];
      self.data.tier_3 = [];
    }

  });

  return MobileMenu;
})();

document.addEventListener("DOMContentLoaded", function(event) {
	var mobileMenuItems = document.querySelectorAll('[data-mobile-menu]');
	if (mobileMenuItems.length > 0){
	  var mobileMenu = new window.odTheme.MobileMenu();
	}
});